import { FORTA_GRAY9 } from '../../utils/colors';

import type { SxProps, Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';

export const COMING_SOON_SX: SxProps<Theme> = {
  display: 'flex',
  flexGrow: 1,
  alignItems: 'center',
  justifyContent: 'center',
};

export const TREATMENT_PLAN_V3_SECTION_HEADING_SX: SystemStyleObject<Theme> = {
  fontFamily: 'DMSansBold',
  fontSize: 20,
  lineHeight: 1.5,
  color: FORTA_GRAY9,
  textAlign: 'left',
};

export const TREATMENT_PLAN_V3_PAGE_HEADING_INSET_SX: SystemStyleObject<Theme> = { px: '10px' };

export const TREATMENT_PLAN_V3_PAGE_BOX_SX: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  textAlign: 'left',
};
